// extracted by mini-css-extract-plugin
module.exports = {"notificationBar":"NotificationBar_notificationBar__uXt2_"};